import { Box, Typography, IconButton, Avatar } from "@mui/material";
import React from "react";
import Slider from "react-slick";
import { ArrowBack, ArrowForward, Star, StarBorder } from "@mui/icons-material";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";

const ReviewSlider = () => {
  const data = [
    {
      name: "Praveen",
      review:
        "Our daughter has become more confident and is doing better in her studies since joining Podar Prep School, Yelahanka. The teachers are kind and really care about the students.",
      avatar: "https://img.icons8.com/color/96/user-male-circle--v1.png",
      rating: 4,
    },
    {
      name: "Mahesh",
      review:
        "Podar Prep School, Yelahanka has a great mix of learning and fun. Our son enjoys studying and also loves music and sports. He is excited to go to school every morning!",
      avatar: "https://img.icons8.com/color/96/user-male-circle--v1.png",
      rating: 4,
    },
    {
      name: "Kavya",
      review:
        "The teachers at Podar Prep School, Yelahanka are always helpful and easy to talk to. They listen to our concerns and support our child in every way. We feel like we are working together as a team.",
      avatar: "https://img.icons8.com/color/96/user-female-circle--v1.png",
      rating: 4,
    },
    {
      name: "Krishnakumar",
      review:
        "We were worried when we moved, but Podar Prep School, Yelahanka made our daughter feel welcome right away. She made friends quickly and now loves going to school.",
      avatar: "https://img.icons8.com/color/96/user-male-circle--v1.png",
      rating: 4,
    },
    {
      name: "Godwin.Benedit",
      review:
        "Our son is growing into a kind and curious boy, thanks to Podar Prep School, Yelahanka. They teach good values along with studies, which is very important to us.",
      avatar: "https://img.icons8.com/color/96/user-male-circle--v1.png",
      rating: 4,
    },
  ];

  const PrevArrow = ({ onClick }) => (
    <IconButton
      aria-label="Previous review"
      onClick={onClick}
      sx={{
        position: "absolute",
        top: "50%",
        left: { xs: "-30px", md: "-40px" },
        transform: "translateY(-50%)",
        zIndex: 1,
        backgroundColor: "#fff",
        "&:hover": { backgroundColor: "#ccc" },
      }}
    >
      <ArrowBack sx={{ color: "#202c45" }} />
    </IconButton>
  );

  const NextArrow = ({ onClick }) => (
    <IconButton
      aria-label="Next review"
      onClick={onClick}
      sx={{
        position: "absolute",
        top: "50%",
        right: { xs: "-30px", md: "-40px" },
        transform: "translateY(-50%)",
        zIndex: 1,
        backgroundColor: "#fff",
        "&:hover": { backgroundColor: "#ccc" },
      }}
    >
      <ArrowForward sx={{ color: "#202c45" }} />
    </IconButton>
  );

  const sliderSettings = {
    dots: true,
    infinite: true,
    speed: 500,
    slidesToShow: 2,
    slidesToScroll: 1,
    arrows: true,
    centerMode: true,
    centerPadding: "30px",
    prevArrow: <PrevArrow />,
    nextArrow: <NextArrow />,
    autoplay: true,
    autoplaySpeed: 3000,

    responsive: [
      {
        breakpoint: 960,
        settings: {
          slidesToShow: 1,
          centerPadding: "10px",
        },
      },
    ],
  };

  const renderStars = (rating) => {
    return Array.from({ length: 5 }, (_, i) =>
      i < rating ? (
        <Star key={i} sx={{ color: "#fbc02d" }} />
      ) : (
        <StarBorder key={i} sx={{ color: "#fbc02d" }} />
      )
    );
  };

  return (
    <Box
      sx={{
        height: { xs: "auto", md: "500px" },

        width: { xs: "90%", md: "100%" },
        mx: "auto",
        textAlign: "center",
        display: "flex",
        flexDirection: "column",
        justifyContent: "center",
        py: 10,
        backgroundImage: {
          xs: "none", // Hide background on mobile
          md: 'url("https://www.littlemillennium.com/assets/img/background/bg9.webp")',
        },
        backgroundRepeat: "no-repeat",
        backgroundSize: "contain",
        backgroundPosition: "center",
        backgroundColor: "#fff",
      }}
    >
      <Box sx={{ mb: 4 }}>
        <Typography variant="h4" fontWeight="bold" color="#202c45">
          What Parents Say
        </Typography>
        <Typography variant="body1" color="text.secondary">
          Honest reviews from families who trust us
        </Typography>
      </Box>

      <Box sx={{ width: "90%", mx: "auto", position: "relative" }}>
        <Slider {...sliderSettings}>
          {data.map((item, index) => (
            <Box key={index} sx={{ px: 0, mb: { xs: 3, md: 0 }, mx: "auto" }}>
              <Box
                sx={{
                  backgroundColor: "#ffffff",
                  borderRadius: 4,
                  boxShadow: 3,
                  p: 2,
                  display: "flex",
                  flexDirection: "column",
                  alignItems: "center",
                  textAlign: "center",
                  maxWidth: { xs: 250, md: 400 },
                  height: { xs: 380, md: 320 },
                  mx: "auto",
                }}
              >
                <Avatar
                  src={item.avatar}
                  alt={`Photo of ${item.name}`}
                  sx={{ width: 100, height: 100, mb: 2 }}
                  loading="lazy"
                />
                <Typography variant="body1" color="text.primary" mb={2}>
                  “{item.review}”
                </Typography>
                <Typography variant="h6" fontWeight="bold">
                  {item.name}
                </Typography>
                <Box sx={{ display: "flex", justifyContent: "center", mt: 1 }}>
                  {renderStars(item.rating)}
                </Box>
              </Box>
            </Box>
          ))}
        </Slider>
      </Box>
    </Box>
  );
};

export default ReviewSlider;
